export default __webpack_public_path__ + "static/km-laptops-a0dad6a93fece969708f41660a8aee37.jpg";